(function () {
  var params = new URLSearchParams(window.location.search);
  var submittedFormId = window.location.hash ? window.location.hash.replace('#', '') : '';

  if (params.get('customer_posted') !== 'true' || submittedFormId.indexOf('America250') !== 0) {
    return;
  }

  var form = document.getElementById(submittedFormId);

  document.querySelectorAll('.site-footer .form-message--success').forEach(function (message) {
    message.classList.add('is-america250-hidden');
  });

  if (!form) {
    return;
  }

  form.classList.add('is-submitted');

  var successMessage = form.querySelector('[data-america250-success-for="' + submittedFormId + '"]');
  if (successMessage) {
    successMessage.hidden = false;
    successMessage.focus();
  }

  var downloadLink = form.querySelector('[data-america250-gated-download]');
  if (!downloadLink || downloadLink.getAttribute('data-auto-open') !== 'true') {
    return;
  }

  var storageKey = 'america250-download-opened-' + submittedFormId;
  if (window.sessionStorage && sessionStorage.getItem(storageKey)) {
    return;
  }

  if (window.sessionStorage) {
    sessionStorage.setItem(storageKey, 'true');
  }

  window.setTimeout(function () {
    downloadLink.click();
  }, 300);
})();
